export default "__VITE_ASSET__DpZhwYjD__"